import * as Actions from './enrollmentActions2.js'

const initialState = {}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.ENROLLMENT_SEARCH:
      return {
        ...state,
        [action.personId]: { loading: true }
      }
    case Actions.ENROLLMENT_FOUND:
      return {
        ...state,
        [action.personId]: action.enrollment
      }
    case Actions.ENROLLMENT_NOT_FOUND:
      return {
        ...state,
        [action.personId]: false
      }
    case Actions.ENROLLMENT_REVOKED:
      return {
        ...state,
        [action.personId]: false
      }
    case Actions.ENROLLMENT_ERROR:
      return {
        ...state,
        [action.personId]: {
          loading: false,
          error: true
        }
      }
    default:
      return state
  }
}
